import { createApi } from '@reduxjs/toolkit/query/react';

import { updateBalance, updateCurrentXp } from '@app/store/utils/cacheUpdate';
import { extractData } from '@app/store/utils/common';
import { DAILY_COOKIES_FEED_COUNT, FEED_XP_GAINED } from '@app/shared/constants/common';
import { BalanceActionType, PriceType } from '@app/shared/types/common';
import { baseQueryWithReauth } from '@app/store/utils/baseQueryWithReauth';
import { UserProgress, FeedPandaResponse, UserProgressTagType } from './userProgressTypes';

export const userProgressApi = createApi({
  reducerPath: 'userProgressApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(UserProgressTagType),
  endpoints: (builder) => ({
    getCurrentUserProgress: builder.query<UserProgress | null, void>({
      query: () => '/user-progress/me',
      transformResponse: extractData,
      providesTags: [UserProgressTagType.CURRENT_USER_PROGRESS],
    }),
    feedPanda: builder.mutation<FeedPandaResponse | null, void>({
      query: () => ({
        url: '/user-progress/feed-panda',
        method: 'POST',
      }),
      transformResponse: extractData,
      onQueryStarted(_, { queryFulfilled, dispatch }) {
        void updateCurrentXp(FEED_XP_GAINED, dispatch, queryFulfilled);
        updateBalance(
          PriceType.COOKIE,
          BalanceActionType.DECREASE,
          DAILY_COOKIES_FEED_COUNT,
          dispatch
        );
      },
    }),
    getUserProgress: builder.query<UserProgress | null, number>({
      query: (userId) => `/user-progress/${String(userId)}`,
      transformResponse: extractData,
      providesTags: [UserProgressTagType.USER_PROGRESS],
    }),
  }),
});

export const { useGetCurrentUserProgressQuery, useGetUserProgressQuery, useFeedPandaMutation } =
  userProgressApi;
